/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_REBATE_PROGRAM = 'GET_REBATE_PROGRAM';
export const GET_REBATE_PROGRAM_NAME = 'GET_REBATE_PROGRAM_NAME';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_ERROR_MSG_REBATE_SUMMARY = 'GET_ERROR_MSG_REBATE_SUMMARY';
export const GET_REBATE_SUMMARY_INVOICED = 'GET_REBATE_SUMMARY_INVOICED';
export const GET_REBATE_SUMMARY_DISPUTE = 'GET_REBATE_SUMMARY_DISPUTE';
export const GET_REBATE_SUMMARY_PAYMENT_RECEIVED =
  'GET_REBATE_SUMMARY_PAYMENT_RECEIVED';
export const DISPLAY_STATE_FISCAL = 'DISPLAY_STATE_FISCAL';
export const GET_DRAMS_INVOICE_START_QUARTER_VALUE =
  'GET_DRAMS_INVOICE_START_QUARTER_VALUE';
export const SET_REFRESH_DATA_REBATE = 'SET_REFRESH_DATA_REBATE';
export const SET_RBT_SUMM_TBL_DATA = 'SET_RBT_SUMM_TBL_DATA';
export const SET_SEARCH_SCREEN_OBJ_DATA_RBT_SUMM =
  'SET_SEARCH_SCREEN_OBJ_DATA_RBT_SUMM';
